import { PageContent } from '../../PageContent';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';

interface PageSkeletonProps {
  breadcrumbs?: number;
  tabs?: number;
  children?: React.ReactNode;
}

/**
 * Reusable page-level skeleton layout with header placeholders and custom content placeholders.
 */
export function PageSkeleton({ breadcrumbs, tabs, children }: PageSkeletonProps) {
  return (
    <>
      <PageHeaderSkeleton breadcrumbs={breadcrumbs} tabs={tabs} />
      <PageContent>{children}</PageContent>
    </>
  );
}
